import React from "react";
import { Divider } from "@mui/material";

import { APICredentialDetailContext } from "contexts/APICredentialDetailContext";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";


import { useApiCredentialDetailQuery } from "store/services/apiCredentialApi";

import { useAppMeta, useAuth } from "hooks";
import APIMetrics from "./apiCredentialComponents/APIMetrics";
import CredentialDetail from "./apiCredentialComponents/CredentialDetail";
import { BaseTabs } from "components/Shared/BaseTabs";

const APICredentialScreen = () => {
  const breadcrumbs = [{ title: "Integration" }];

  const tabs = [
    { label: "Metrics", value: "metrics", component: <APIMetrics /> },
  ];

  const { loggedInUser } = useAuth();

  // RTK Query
  const {
    data: credential,
    isLoading: loadingCredential,
    refetch,
  } = useApiCredentialDetailQuery(loggedInUser?.typeRef);

  useAppMeta("API Integration");

  return (
    <APICredentialDetailContext.Provider
      value={{ credential, loadingCredential, refetch }}
    >
      <BreadcrumbLayout breadcrumbs={breadcrumbs}>
        <BreadcrumbLayout.Paper>
          <CredentialDetail />

          {!!credential && (
            <>
              <Divider />

              <BaseTabs tabs={tabs} />
            </>
          )}
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </APICredentialDetailContext.Provider>
  );
};

export default APICredentialScreen;
